import { i18n } from '@/shared/i18n';
import type { BriefTemplateStatus } from './BriefTemplateStatusBadge.types';

type BadgeVariant = 'default' | 'secondary' | 'outline' | 'warning' | 'positive' | 'destructive';

interface StatusBadgeInfo {
  label: string;
  variant: BadgeVariant;
}

export function resolveStatusBadge(
  status: BriefTemplateStatus | undefined,
  enabled?: boolean,
): StatusBadgeInfo {
  if (enabled === false) {
    return {
      label: i18n.t('knowledge:knowledgeHub.briefTemplateStatusBadge.off'),
      variant: 'outline',
    };
  }

  // Resolved per call rather than once at module scope, so the label follows the language.
  const draftBadge: StatusBadgeInfo = {
    label: i18n.t('projects:project.constants.draft'),
    variant: 'default',
  };
  const map: Record<BriefTemplateStatus, StatusBadgeInfo> = {
    draft: draftBadge,
    published: {
      label: i18n.t('contentTest:emailFlowWidget.publishTemplateModal.published'),
      variant: 'positive',
    },
  };

  return status && status in map ? map[status] : draftBadge;
}
